export default "__VITE_ASSET__a6409b62__"